import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import is from 'is_js';
import { connect } from 'omni-common-ui';
import PropTypes from 'prop-types';

import { actions as GroupMembers } from 'data/GroupMembers';
import { actions as unitQuizResultsActions } from 'data/UnitQuiz';
import { actions as Session } from 'data/SessionPlans';
import { getUnitList } from 'data/Units/accessors';
import CourseViewTable from 'components/CourseViewTable';

const skills = ['Reading', 'Listening', 'Phonics', 'Total'];

export class UnitQuiz extends Component {

  componentWillMount() {
    this.props.fetchUnitQuizResultsIfNeeded(this.props.groupId);
  }

  _getHighlightedColumns() {
    const { units, defaultUnits } = this.props;

    if (is.undefined(units)) {
      return [0];
    }

    const unitIds = units.valueSeq().toArray().map((u) => u.id);

    return is.undefined(defaultUnits) ? [0] : defaultUnits.map((u) => unitIds.indexOf(u));
  }

  _renderUnitColumns(units) {
    const cellItems = [];

    if (is.undefined(units) || units.size === 0) {
      return cellItems;
    }

    cellItems.push(
      units.valueSeq().toArray().map((unit) =>
        <CourseViewTable.Cell key={`${unit.id}`}
            columnId={unit.id}
            small>
          {unit.name}
        </CourseViewTable.Cell>)
    );

    return cellItems;
  }

  render() {
    const { members, units, studentUnitQuizResults } = this.props;

    if (is.undefined(members) || members.size === 0) {
      return null;
    }

    const rows = members.map((member) =>
      skills.map((skill) => member.set('skill', skill))).reduce((a, b) => a.concat(b));

    return <div>
      <CourseViewTable students={rows} showSkill highlightedColumns={this._getHighlightedColumns()}>
        <CourseViewTable.Header>
          <CourseViewTable.Row>{this._renderUnitColumns(units)}</CourseViewTable.Row>
        </CourseViewTable.Header>
        <CourseViewTable.Body>
          {(member, column) => {
            if (is.undefined(studentUnitQuizResults)) {
              return null;
            }

            let content;
            const studentUnitQuizResult = studentUnitQuizResults
              .filter((r) => r.studentId === member.studentGeneralInfo.id).first();
            const unitQuizResult = is.undefined(studentUnitQuizResult) ?
              undefined :
              studentUnitQuizResult.unitQuizResults.filter((r) => r.unitId === column).first();

            if (member.skill === 'Total') {
              content = is.undefined(unitQuizResult) ? null : `${unitQuizResult.totalScore}%`;
            } else {
              const skillResult = is.undefined(unitQuizResult) ?
                undefined :
                unitQuizResult.skillResults
                  .filter((r) => r.skill.toUpperCase() === member.skill.toUpperCase()).first();

              content = is.undefined(skillResult) ? null : `${skillResult.score}/${skillResult.totalScore}`;
            }

            return <div>{content}</div>;
          }}
        </CourseViewTable.Body>
      </CourseViewTable>
    </div>;
  }
}

UnitQuiz.propTypes = {
  groupId: PropTypes.string.isRequired,
  members: PropTypes.object,
  units: PropTypes.object,
  defaultUnits: PropTypes.object,
  studentUnitQuizResults: PropTypes.object,
  fetchUnitQuizResultsIfNeeded: PropTypes.func,
};

export function mapStateToProps(state, ownProps) {
  const { groupId } = ownProps.params;
  const members = GroupMembers.getMembersByGroup(state, groupId);
  const units = getUnitList(state, groupId);
  const defaultUnits = Session.getDefaultUnits(state, groupId);
  const studentUnitQuizResults = state
    .get('rootReducer')
    .get('unitQuizResult')
    .get(groupId);

  return {
    groupId,
    members,
    units,
    defaultUnits,
    studentUnitQuizResults,
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign(bindActionCreators(unitQuizResultsActions, dispatch));
}

export default connect(mapStateToProps, mapDispatchToProps)(UnitQuiz);



// WEBPACK FOOTER //
// ./containers/Group/Homework/UnitQuiz/component.jsx